<div class="body">
    <app-generate-orden class="generate-order"></app-generate-orden>
    <app-featured-prices class="featured-prices"></app-featured-prices>
    <app-market-prices class="market-prices"></app-market-prices>
    <app-order class="order-list">
    </app-order>
    <app-future-markets class="future-markets"></app-future-markets>
    <app-goals class="goals"></app-goals>
</div>